import * as React from "react";
import {AddCircleTwoTone, Delete, CloudUploadTwoTone} from "@material-ui/icons";
import Table from "@material-ui/core/Table";
import {TableHead} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import * as PropTypes from "prop-types";
import withStyles from "@material-ui/styles/withStyles";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from '@material-ui/core/TablePagination';
import {GreenButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import TextField from "@material-ui/core/TextField";
import {downloadFile} from "../../util/ApiUtils";
import { t } from '../../i18n';

const classes = () => ({
    root: {
        borderTopWidth: 1,
        borderColor: 'red',
    }
});

class TableComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tableKey: props.tableKey,
            data: props.data,
            columns: props.columns,
            currentPage: 0,
        };
        this.onPageChange = this.onPageChange.bind(this);
    }

    onPageChange(event, page) {
        this.setState({
            currentPage: page
        })
    }

    handleRowDel(item) {
        if (this.props.handleRowDel) {
            this.props.handleRowDel(item);
        }
        let index = this.state.data.indexOf(item);
        this.state.data.splice(index, 1);
        this.setState(this.state.data);
    };

    handleAddEvent() {
        if (!this.props.handleAddRow) {
            let item = {};
            this.state.columns.map((column) =>
                item[column.id] = ''
            );
            this.state.data.push(item);
            this.setState(this.state.data);
        } else {
            this.props.handleAddRow();
        }
    }

    handleTableUpdate(evt) {
        let item = {
            id: evt.target.id,
            name: evt.target.name,
            value: evt.target.value
        };
        let data = this.state.data.slice();
        let tableKey = this.state.tableKey;
        let newData = data.map(function(row, index) {
            for (let key in row) {
                if (key === item.name && (tableKey + '_' + item.name + '_' + index) === item.id) {
                    data[index][key] = item.value;
                }
            }
            return row;
        });
        this.setState({data:newData});
    };

    handleSubmitEvent() {
        this.props.handleSubmit(this.state.data);
    }

    onInlineSubmitEvent() {
        this.props.onInlineSubmit(this.state.data);
    }

    handleEdit(item) {
        this.props.handleRowEdit(item);
    }

    render() {

        return (
            <div>
                <EditableTable
                    tableKey={this.props.tableKey}
                    onTableUpdate={this.handleTableUpdate.bind(this)}
                    onRowAdd={this.handleAddEvent.bind(this)}
                    onRowDel={this.handleRowDel.bind(this)}
                    onRowEdit={this.handleEdit.bind(this)}
                    data={this.state.data}
                    columns={this.state.columns}
                    onSubmit={this.props.handleSubmit && this.handleSubmitEvent.bind(this)}
                    onInlineSubmit={this.props.onInlineSubmit && this.onInlineSubmitEvent.bind(this)}
                    classes={this.props.classes}
                    onPageChange={this.onPageChange}
                    currentPage={this.state.currentPage}
                    allowAdd={this.props.allowAdd}
                    pagination={this.props.pagination}
                    allowUpdateDelete={this.props.allowUpdateDelete}
                />
            </div>
        );
    }
}

class EditableTable extends React.Component {

    onDelEvent(item) {
        this.props.onRowDel(item);
    }

    onEditEvent(item) {
        this.props.onRowEdit(item);
    }

    render() {
        let onTableUpdate = this.props.onTableUpdate;
        let onSubmit = this.props.onSubmit;
        let onInlineSubmit = this.props.onInlineSubmit;
        let tableKey = this.props.tableKey;
        let columns = this.props.columns;
        let pageCount = Object.keys(this.props.data).length;
        return (
            <div>
                <Table className={this.props.classes.root} id={tableKey} style={{ padding: '20px' }}>
                    <TableHead style={{ textAlign: 'left' }}>
                        <td colSpan={columns.length + 2}>
                                <span>
                                    {
                                        this.props.allowAdd === 'show' ?
                                            <OrangeButton
                                                variant="contained"
                                                color="secondary"
                                                startIcon={<AddCircleTwoTone/>}
                                                size="small"
                                                onClick={this.props.onRowAdd}
                                                style={{marginRight: '0px', marginBottom: '20px', float: 'right', height: '38px', marginTop: "-40px"}}
                                            >
                                                { t('common.add') }
                                            </OrangeButton>
                                            :
                                            (this.props.allowAdd === 'disable' ?
                                                    <GreenButton
                                                        variant="contained"
                                                        color="secondary"
                                                        startIcon={<AddCircleTwoTone/>}
                                                        size="small"
                                                        onClick={this.props.onRowAdd}
                                                        disabled
                                                        style={{marginLeft: '20px', marginBottom: '20px', float: 'left'}}
                                                    >
                                                        { t('common.add') }
                                                    </GreenButton>
                                                    :
                                                    null
                                             )}
                                </span>
                        </td>
                        <tr>
                            {columns.map((column) =>
                                <th id={column.id} style={{ padding: '20px', paddingRight: '40px' }}>{column.name}</th>
                            )}
                            <th style={{ paddingRight: '20px', paddingTop: '20px', width: '20%' }}></th>
                        </tr>
                    </TableHead>
                    <TableBody>
                        { this.props.data.length > 0
                            ? this.props.data.map((item, key) =>
                                <tr className="eachRow">
                                    {this.props.columns.map((column, index) =>
                                        <EditableCell
                                            onTableUpdate={onTableUpdate}
                                            onRowEdit={this.props.onRowEdit}
                                            cellData={{
                                                type: key,
                                                value: item[column.id],
                                                id: tableKey + '_' + column.id + '_' + key,
                                                isEditable: column.isEditable,
                                                immutable: item.immutable,
                                                fileId: item.fileId,
                                                clickable: column.clickable,
                                                item: item
                                            }}
                                            column={columns[index]}
                                        />
                                    )}
                                    <td className="del-cell" style={{paddingBottom: '20px'}}>
                                        {!onInlineSubmit && this.props.allowUpdateDelete !== 'no' &&
                                            <GreenButton
                                                variant="contained"
                                                color="secondary"
                                                startIcon={<Delete/>}
                                                onClick={() => this.onEditEvent(item)}
                                                size="small"
                                                style={{marginRight: '10px'}}
                                                disabled={item.immutable}
                                            >
                                                { t('common.update') }
                                            </GreenButton>
                                        }
                                        {this.props.allowUpdateDelete !== 'no' &&
                                        <RedButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<Delete/>}
                                            onClick={() => this.onDelEvent(item)}
                                            size="small"
                                            disabled={item.immutable}
                                        >
                                            { t('common.remove') }
                                        </RedButton>}
                                        {onSubmit &&
                                        <OrangeButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<CloudUploadTwoTone/>}
                                            size="small"
                                            onClick={onSubmit}
                                            style={{marginRight: '20px', marginLeft: '20px'}}
                                        >
                                            { t('common.save') }
                                        </OrangeButton>}
                                    </td>
                                </tr>
                            )
                            : <tr><td colSpan={this.props.columns.length + 1} style={{padding: '20px', margin: '20px', borderTop: '1px solid grey', textColor: 'grey'}}>{ t('common.noResults') }</td></tr>
                        }
                    </TableBody>
                    <TableFooter>
                        <tr>
                            <td colSpan={columns.length}>
                                <span>
                                    {onInlineSubmit &&
                                    <OrangeButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<CloudUploadTwoTone/>}
                                        size="small"
                                        onClick={onInlineSubmit}
                                        style={{marginRight: '20px', marginLeft: '20px', float: 'left' }}
                                    >
                                        { t('common.save') }
                                    </OrangeButton>}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            {this.props.pagination &&
                            <TablePagination
                                count={pageCount}
                                onChangePage={this.props.onPageChange}
                                page={this.props.currentPage}
                                rowsPerPage={25}
                                rowsPerPageOptions={[25]}
                            />}
                        </tr>
                    </TableFooter>
                </Table>
            </div>
        );
    }
}

class EditableCell extends React.Component {
    getStyle = () => {
        let cellStyle = {
            color: 'inherit'
        };

        if (typeof this.props.column.cellStyle === 'function') {
            cellStyle = { ...cellStyle, ...this.props.column.cellStyle(this.props.cellData) };
        } else {
            cellStyle = { ...cellStyle, ...this.props.column.cellStyle };
        }

        if (this.props.column.disableClick) {
            cellStyle.cursor = 'default';
        }

        return { ...this.props.style, ...cellStyle };
    };
    render() {
        return (
            <td style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '20px', textAlign: 'left' }}>
                {((!this.props.cellData.isEditable)
                        ?
                        (
                            (this.props.column.type === 'file') ?
                                ((this.props.cellData.fileId)
                                    ? <a href="#" onClick={() => downloadFile(this.props.cellData.fileId)}>{ this.props.cellData.value }</a>
                                    : <span>{ t('context.common.na') }</span>)
                            : (this.props.column.type === 'boolean') ?
                                <span>{ this.props.cellData.value ? t('common.yes') : t('common.no') }</span>
                                        :
                                ((this.props.cellData.clickable === 'true') ? <a href="javascript:void(0)" onClick={() => this.props.onRowEdit(this.props.cellData.item)}>{this.props.cellData.value}</a> : <span style={this.getStyle()}>{this.props.cellData.value}</span>)
                        )
                        :
                        ((this.props.column.type === 'text') ?
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name={this.props.column.id}
                                    id={this.props.cellData.id}
                                    value={this.props.cellData.value}
                                    onChange={this.props.onTableUpdate}
                                    type={this.props.column.type}
                                />
                                :
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name={this.props.column.id}
                                id={this.props.cellData.id}
                                value={this.props.cellData.value}
                                onChange={this.props.onTableUpdate}
                                multiline
                                rows="4"
                            />)
                )}
            </td>
        );

    }
}

TableComponent.propTypes = {
    tableKey: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    handleSubmit: PropTypes.func,
    onInlineSubmit: PropTypes.func,
    handleAddRow: PropTypes.func,
    handleRowDel: PropTypes.func,
    handleRowEdit: PropTypes.func,
    allowAdd: PropTypes.string,
    pagination: PropTypes.bool,
    allowUpdateDelete: PropTypes.string,
};

export default withStyles(classes)(TableComponent);
